/** Angular */
import {Injectable} from '@angular/core';

@Injectable()
export class Globals {
    activeAssignmentId: number;
    activeTOEId: number;
    activeTPId: number;
}
